module.exports = __webpack_public_path__ + "2acb60f2/img/pwrd-by-sourcery-black.bba9ba41.svg";